import { render, staticRenderFns } from "./ServiceAgreementTemplate.vue?vue&type=template&id=0413574f&"
import script from "./ServiceAgreementTemplate.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ServiceAgreementTemplate.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports